import { get } from '@/helpers';

export default {
  computed: {
    settings() {
      return get(this.section, 'settings') || [];
    },
    style() {
      const style = {};
      if (this.section.margin_top === 'custom' && this.section.margin_top_custom_value) {
        style['margin-top'] = this.section.margin_top_custom_value;
      }
      if (this.section.margin_bottom === 'custom' && this.section.margin_bottom_custom_value) {
        style['margin-bottom'] = this.section.margin_bottom_custom_value;
      }
      return style;
    },
    classes() {
      let classes = [this.section.key, 'co-section'];
      if (this.section.margin_top && this.section.margin_top !== 'custom') {
        classes.push(`margin-top-${this.section.margin_top}`);
      }
      if (this.section.margin_bottom && this.section.margin_bottom !== 'custom') {
        classes.push(`margin-bottom-${this.section.margin_bottom}`);
      }
      return classes;
    }
  }
};
